import PropTypes from 'prop-types';
// NATIONAL PARKS: Please remove this disable and try to fix it if you're here
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { Component } from 'sitewide-react';
import RedesignedMentionsPing from './redesigned_mentions_ping';

class ProfileHitMentionPing extends RedesignedMentionsPing {
  getBody() {
    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is mentioned in a
        paper in <strong>{this.props.authorName}</strong>'s research area,{' '}
        <strong>{this.props.researchInterestName}</strong>
      </div>
    );
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'searchm',
      trigger: 'profile-hit-mention-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.mentions_path()),
    });
  }
}

ProfileHitMentionPing.propTypes = {
  mentionedName: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
};

export default ProfileHitMentionPing;
